export default __webpack_public_path__ + "static/media/event_reg.25326b94.png";